/**
 * Created by maciej on 22/06/2016.
 */
import {app} from '../app';

export interface IUniqueIdService {
    getUniqueId(string): string;
}

interface IUniqueIdEntry {
    key: string,
    repetitions: number
}

export class UniqueIdService implements IUniqueIdService {

    private filter:IFilterService;

    private ids: IUniqueIdEntry[] = [];

    constructor($filter:IFilterService) {

        this.filter = $filter;

    }

    public getUniqueId(key: string): string {
        key = this.filter('slugify')(key);

        for (let entry of this.ids) {
            if (entry.key === key) {
                entry.repetitions++;
                return entry.key + '-' + entry.repetitions;
            }
        }

        this.ids.push({
            key: key,
            repetitions: 1
        });

        return key + '-' + 1;
    }

    static factory() {
        const factory = ($filter:IFilterService) => new UniqueIdService($filter);
        factory.$inject = ['$filter'];
        return factory;
    }

}

app.factory('UniqueIdService', UniqueIdService.factory());